import api from "./api";

// Capa de servicios API del dominio "informativos" (announcements) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- CRUD ---
export const listAnnouncements = (params) =>
  api.get("/announcements/", { params });
export const findAnnouncementById = (announcementId) =>
  api.get(`/announcements/${announcementId}`);
export const createAnnouncement = (payload) =>
  api.post("/announcements", payload);
export const updateAnnouncement = (announcementId, payload) =>
  api.put(`/announcements/${announcementId}`, payload);
export const deleteAnnouncement = (announcementId) =>
  api.delete(`/announcements/${announcementId}`);

// --- Media ---
export const uploadAnnouncementMedia = (announcementId, formData) =>
  api.post(`/announcements/${announcementId}/media-upload`, formData);
export const deleteAnnouncementMedia = (announcementId) =>
  api.delete(`/announcements/${announcementId}/media-upload`);

// ACK de informativos (helper announcementAckStorage).
export const markAnnouncementRead = (announcementId) =>
  api.post(`/announcements/${announcementId}/read`);
export const bulkReadAnnouncements = (announcementIds) =>
  api.post("/announcements/bulk-read", { announcementIds });
